<template>
  <div class="content">
    <b-row class="tip">
      <b-col cols="7">
        <h6 class="text-nowrap">{{ $t("companyName") }}</h6>
      </b-col>
      <b-col cols="2">
        <i class="fa fa-phone"></i>
        <h6>+86 19917 199866</h6>
      </b-col>
      <b-col cols="3">
        <i class="fa fa-envelope"></i>
        <h6>admin@ptfe-diaphragm.com</h6>
      </b-col>
    </b-row>
    <b-row class="nav" align-v="center" v-if="$_isMobile()">
      <b-button variant="outline-primary" style="width:60px" v-b-toggle.sidebar-right>
        <i class="fa fa-align-left" aria-hidden="true"></i>
        <!-- <b-icon icon="text-left" aria-label="Help"></b-icon> -->
      </b-button>
      
      <b-col cols="2" style="width: 120px;">
        <SelectLang />
      </b-col>
    </b-row>
    <b-row class="nav" align-v="center" v-else>
      <b-col cols="3">
        <b-img
          :src="logoUrl"
          v-bind="LogoProps"
          fluid
          alt="Responsive image"
        ></b-img>
        <!-- <img alt="Vue logo" src="../assets/logo.png"/> -->
      </b-col>
      <b-col cols="7">
        <NavBtn v-for="(item, index) in navBarData" :key="index" :item="item" :cardData="cardData" />
      </b-col>
      <b-col cols="2">
        <SelectLang />
      </b-col>
    </b-row>
    <b-sidebar id="sidebar-right"  right>
      <b-col cols="7" style="display: flex;flex-direction: column;">
        <NavBtn v-for="(item, index) in navBarData" :key="index" :item="item"  :cardData="cardData"/>
      </b-col>
    </b-sidebar>
  </div>
</template>

<script>
import logoUrl from "@/assets/logo.png";
import NavBtn from "./components/NavBtn";
import SelectLang from "./components/SelectLang";
import Resize from "@/mixin/Resize";
import { 
  Categroy as productApi,
} from '@/api/product'
import {
  mapGetters
} from 'vuex'
export default {
  mixins: [Resize],
  data() {
    return {
      logoUrl: logoUrl,
      LogoProps: { width: 110, height: 110, class: "m1" },
      navBarData: [],
      cardData:[]
    };
  },
  computed: {
    ...mapGetters([
      'langs',
    ])
  },
  components: {
    NavBtn,
    SelectLang,
  },
  watch: {
    $route() {
      this.getNarbarData();
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getNarbarData() {
      let routerData = [];
      let routePath = this.$route.path.replace("/", "");
      // console.log(routePath.replace('/',''))
      this.$router.options.routes.map((Element) => {
        Element.children.map((item) => {
          // console.log(item)
          if (item.isNarbar) {
            routerData.push({
              active: routePath == item.path ? true : false,
              // text:  item.path== '/' ? 'home': item.path,
              // path:  item.path== '/' ? '/': item.path,
              text: item.path,
              path: item.path,
            });
          }
        });
      });
      this.navBarData = routerData;
    },
  },
  mounted() {
    console.log(this);
    this.getNarbarData();
    if (this.$_isMobile()) {
      console.log("13123");
    }
    productApi({
      page:1 ,
      rows:10,
      lang: this.langs
    }).then(rep => {
      let data = rep.data.data;
      data.map(item => {
        this.cardData.push(item)
      })
    })
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  // overflow: hidden;
}
.tip {
  padding: 8px 80px;
  background: #758dc9;
  color: #fff;
  width: 100%;
  margin: 0;
  h6 {
    display: inline-block;
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.nav {
  padding: 8px 80px;
  padding-right: 20px;
  width: 100%;
  margin: 0 !important;
}
</style>
<style lang="scss" scoped>
@media only screen and (max-width: 667px) {
  .col-7,
  .col-3,
  .col-2 {
    width: 100%;
    padding: 0;
  }
  h6 {
    font-size: 0.9rem;
  }
  .tip {
    padding: 8px 40px;
  }
  .nav {
     padding: 8px 16px;
    display: flex;
    justify-content: space-between;
  }
  .cotent{
    width: 100%;
  }
  .items{
    z-index: 999;
  }
}
</style>